import dayjs from 'dayjs';
import { observer } from 'mobx-react-lite';
import { useTeachingBlockStore } from '../Contexts/TeachingBlockContext';
import styles from './GridHeader.module.scss';
import { GridHeaderMonth } from './GridHeaderMonth';
import { GridHeaderWeeks } from './GridHeaderWeeks';

export const GridHeader = observer(() => {
  const store = useTeachingBlockStore();

  const dateEntries = Array.from(store.dates.values());
  const totalDays = dateEntries.length;
  const months = dateEntries.reduce<Array<{ dateString: string; dayCount: number; showLabel: boolean }>>(
    (result, day) => {
      const currentMonthKey = dayjs(day.dateString).format('YYYY-MM');
      const lastMonth = result.at(-1);

      if (lastMonth && dayjs(lastMonth.dateString).format('YYYY-MM') === currentMonthKey) {
        lastMonth.dayCount += 1;
        lastMonth.showLabel = lastMonth.dayCount === dayjs(lastMonth.dateString).daysInMonth();
        return result;
      }

      result.push({
        dateString: day.dateString,
        dayCount: 1,
        showLabel: dayjs(day.dateString).daysInMonth() === 1,
      });
      return result;
    },
    [],
  );

  const toggleAllRowSelection = () => {
    store.selectedRows.length > 0 && store.selectedRows.length === store.rows.length
      ? store.selectRows([])
      : store.selectRows(store.rows);
  };

  return (
    <div className={styles['grid-header']}>
      <div
        className={styles['toggle-all']}
        title='Click to select/deselect all'
        onClick={() => toggleAllRowSelection()}
      ></div>
      <div className={styles.wrapper}>
        <div className={styles.months}>
          {months.map((month, i) => (
            <GridHeaderMonth
              key={`${month.dateString}_${i}`}
              dateString={month.dateString}
              showLabel={month.showLabel}
              widthPercent={totalDays > 0 ? (month.dayCount / totalDays) * 100 : 0}
            />
          ))}
        </div>
        <GridHeaderWeeks weeks={store.weeks} />
      </div>
    </div>
  );
});
